import React from 'react';
import { X } from 'lucide-react';

export const Lightbox = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;
  return (
    <div className="lightbox-overlay" onClick={onClose} data-testid="lightbox-overlay">
      <button
        className="absolute top-4 right-4 text-white hover:text-[#E3000F]"
        onClick={onClose}
        data-testid="lightbox-close-btn"
      >
        <X className="w-8 h-8" />
      </button>
      <img
        src={imageUrl}
        alt="Lightbox"
        className="lightbox-image"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};
